import { render, staticRenderFns } from "./CalendarAdmin.vue?vue&type=template&id=59fdb27a&"
import script from "./CalendarAdmin.vue?vue&type=script&lang=ts&"
export * from "./CalendarAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports